// Pages
export const LANDING_PAGE = 'Landing_page';
export const ACCOUNT_PAGE = 'Account_page';
export const ORGANIZATIONS_PAGE = 'Organizations_page';
export const INITIATED_ADDING_NEW_DATASTORE = 'Initiated_Adding_New_Datastore';
export const INITIATED_ADDING_NEW_VPC = 'Initiated_Adding_New_VPC';
export const ERROR_404_PAGE = 'Error_404_Page';
export const DEPLOYMENT_COMPARE_PAGE = 'Deployment_Compare_Page';
export const DATASTORE_TAB = 'DataStore_tab_';
export const OPEN_COMMON_MODAL_FORM = 'Open_Common_Modal_Form_';
export const CANCEL_COMMON_MODAL_FORM = 'Cancel_Common_Modal_Form_';

// Events
export const CLICK_EVENT = 'click';

// Event Actions
export const DATASTORE_BACKUP_SETTINGS_UPDATED =
    'datastore_backup_settings_updated';
export const DATASTORE_ADDING_TRUSTED_SOURCE =
    'datastore_adding_trusted_source';
export const DATASTORE_ADDED_TRUSTED_SOURCE_FIREWALL_SUCCESSFULLY =
    'datastore_added_trusted_source_firewall_successfully';
export const DATASTORE_ADDED_TRUSTED_SOURCE_FIREWALL_FAILED =
    'datastore_added_trusted_source_firewall_failed';
export const DATASTORE_ADDED_DB_PARAMETERS = 'datastore_added_db_parameters';
export const DATASTORE_FAILED_TO_ADD_DB_PARAMETERS =
    'datastore_failed_to_add_db_parameters';
export const DATASTORE_ADDED_NEW_DB_PARAMETERS =
    'datastore_added_new_db_parameters';
export const DATASTORE_ADDING_DATABASE_TRIGGERED_SUCCESSFULLY =
    'datastore_adding_database_triggered_successfully';
export const DATASTORE_ADDING_DATABASE_TRIGGERED_FAILED =
    'datastore_adding_database_triggered_failed';
export const DATASTORE_DB_USER_ALREADY_EXISTS =
    'datastore_db_user_already_exists';
export const DATASTORE_ADD_NEW_DB_USER_TRIGGERED_SUCCESSFULLY =
    'datastore_new_db_user_triggered_successfully';
export const DATASTORE_ADD_NEW_DB_USER_TRIGGERED_FAILED =
    'datastore_new_db_user_trggered_failed';
export const DATASTORE_UPDATE_DB_USER_TRIGGERED_SUCCESSFULLY =
    'datastore_update_db_user_triggered_successfully';
export const DATASTORE_UPDATE_DB_USER_TRIGGERED_FAILED =
    'datastore_update_db_user_trggered_failed';
export const CREATE_NEW_DATASTORE_SUCCESS = 'create_new_datastore_success';
export const CREATE_NEW_DATASTORE_ERROR = 'create_new_datastore_error';
export const CREATE_NEW_VPC_SUCCESS = 'create_new_vpc_success';
export const CREATE_NEW_VPC_ERROR = 'create_new_vpc_error';
export const DATASTORE_UPGRADING_STORAGE_TRIGGERED_SUCCESSFULLY =
    'datastore_upgrading_storage_triggered_successfully';
export const DATASTORE_UPGRADING_STORAGE_TRIGGERED_FAILED =
    'datastore_upgrading_storage_triggered_failed';
export const OPEN_DATASTORE_SCALE_NODES_MODAL =
    'open_datastore_scale_nodes_modal';
export const OPEN_DATASTORE_UPGRADE_STORAGE_MODAL =
    'open_datastore_upgrade_storage_modal';
export const DATASTORE_SACLING_NODES_TRIGGERED_SUCCESSFULLY =
    'datastore_sacling_nodes_triggered';
export const DATASTORE_SACLING_NODES_TRIGGERED_FAILED =
    'datastore_sacling_nodes_triggered_failed';
export const DATASTORE_EXTEND_STORAGE_TRIGGERED_SUCCESSFULLY =
    'datastore_extend_storage_triggered_successfully';
export const DATASTORE_EXTEND_STORAGE_TRIGGERED_FAILED =
    'datastore_extend_storage_triggered_failed';
export const ADDING_NEW_CARD_TRIGGERED_SUCCESSFULLY =
    'adding_new_card_triggered_successfully';
export const ADDING_NEW_CARD_TRIGGERED_FAILED =
    'adding_new_card_triggered_failed';
export const DATASTORE_ADDING_VPC_PEERING_SUCCESSFULLY =
    'datastore_adding_vpc_peering_successfully';
export const DATASTORE_ADDING_VPC_PEERING_FAILED =
    'datastore_adding_vpc_peering_failed';
